export default __webpack_public_path__ + "static/media/Logo_White.7c955182.svg";